<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {getToken} from "@/libs/util";
export default {
  name: "App",
  mounted() {},
  methods: {
    ...mapActions(["GetUserInfo"]),
  },
  computed: mapGetters({
    user: "company",
  }),
};
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}
html,
body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
.content-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e8eaec;
  padding-bottom: 5px;
  margin-bottom: 8px;
  line-height: 38px;
  .left {
    display: flex;
    align-items: center;
    margin: 0 0 9px 0;
    .title {
      font-size: 24px;
      color: black;
      font-weight: bold;
    }
    .describe {
      font-size: 12px;
      color: #aaa;
      margin-left: 20px;
      height: 25px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    margin: 0 0 9px 0;
  }
}
.filter-box {
  // padding-top: 15px;
  margin-bottom: 20px;
  .bottom {
    margin-top: 15px;
    .btn-filter {
      background: #4788f7;
      padding: 9px 16px;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
    }
    .btn {
      background: white;
      border: 1px solid #dedede;
      padding: 9px 16px;
      margin-left: 10px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
  .subtitle {
    font-size: 14px;
    color: black;
  }
}
.t-left {
  text-align: left;
}
.t-right {
  text-align: right;
  margin-top: 10px;
}
.t-center {
  text-align: center;
}
.company-area {
  .ivu-input {
    background-color: #f5f5f5 !important;
    border: 0;
    outline: none;
    &:focus {
      border: 0 !important;
      outline: none !important;
    }
    &:hover {
      border: 0 !important;
      outline: none !important;
    }
    &::-webkit-input-placeholder {
      color: #666;
    }
  }
}
.company-select {
  .ivu-select-selection {
    background-color: #f5f5f5 !important;
    border: 0;
    outline: none;
    &:focus {
      border: 0 !important;
      outline: none !important;
    }
    &:hover {
      border: 0 !important;
      outline: none !important;
    }
    .ivu-select-placeholder {
      color: #666 !important;
      text-align: left;
      margin-left: -10px;
    }
  }
}
//登录页面轮播组件样式重写
.ivu-carousel {
  width: 100%;
  height: 100%;
}

.ivu-modal-header-inner,.ivu-form-item-label{
  color: #000 !important;
}
.ivu-select-selected-value{
    color: #000000 !important;
}
.ivu-input,.ivu-input-group-prepend, .ivu-input-group-append{
  color: #000000 !important;
}
.ivu-checkbox-wrapper{
  color: #000000 !important;
}

//设置筛选组件的文字大小
.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
  font-size: 14px !important;
}
.ivu-input,.ivu-radio-group-button .ivu-radio-wrapper{
  font-size: 14px !important;
}

.ivu-form .ivu-form-item-label{
  font-size: 14px !important;
}

.tips{
  background: #EAF7FD;
  border-radius: 4px;
  padding: 8px 6px;
  color: #4a5163;
  font-size: 12px;
  display: flex;
}

.spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from { transform: rotate(0deg);}
  50%  { transform: rotate(180deg);}
  to   { transform: rotate(360deg);}
}
.ivu-spin-show-text .ivu-spin-text{
  margin-top: -200px;
}
</style>
